
import { Junction } from "./map/junction";
import { DensityAwareSprayAndWait } from "./messages/density.aware.spray.and.wait/density.aware.spray.and.wait";
import { MessagingSystem } from "./messages/messaging.system";
import { SprayAndWait } from "./messages/spray.and.wait";
import { Settings } from "./settings/settings";


export class Node {

    public static readonly ELEMENT_SIZE = 10;
    public static readonly MOVEMENT_SPEED = 100;
    // public static readonly SIMULATION_SPEED = 1; // todo: move, nott o do with node.
    public static readonly HEADER_OFFSET = 55.6;

    public messagingSystem: any;

    private element: HTMLElement = document.createElement('div');
    private radius: HTMLElement = document.createElement('div');

    private nodeAnimation: Animation = new Animation();
    private radiusAnimation: Animation = new Animation();

    public colour: string;

    public x: number;
    public y: number;

    public prevJunction: Junction|undefined;

    constructor(public curJunction: Junction, public id: number, private settings: Settings) {
        let algorithm: typeof SprayAndWait| typeof DensityAwareSprayAndWait;

        if(this.settings.algorithm == MessagingSystem.SprayAndWait) {
            algorithm = SprayAndWait;
        } else {
            algorithm = DensityAwareSprayAndWait;
        }

        this.x = curJunction.x;
        this.y = curJunction.y;

        this.messagingSystem = new algorithm(this.id.toString(), settings);

        this.colour = Math.random().toString(16).slice(2, 8).toUpperCase();

        this.drawNode();
        this.randomlyMove();
    }


    initialiseNode() {
        this.element.classList.add('node');
        this.element.style.width = Node.ELEMENT_SIZE + 'px';
        this.element.style.height = Node.ELEMENT_SIZE + 'px';
        this.element.style.backgroundColor = '#' + this.colour;
        this.element.style.left = (this.x - Node.ELEMENT_SIZE / 2) + 'px';
        this.element.style.top = (Node.HEADER_OFFSET + this.y) + 'px';
        this.element.style.position = 'absolute';
        this.element.style.borderRadius = '100px';

        this.radius.classList.add('radius');
        this.radius.style.left = (this.x - this.settings.nodeRadius / 2) + 'px';
        this.radius.style.top = (this.y + Node.ELEMENT_SIZE) + 'px';
        this.radius.style.width = this.settings.nodeRadius + 'px';
        this.radius.style.height = this.settings.nodeRadius + 'px';
        this.radius.style.position = 'absolute';
        this.radius.style.borderRadius = '100px';
        this.radius.style.border = ' 2px dotted #' + this.colour + ''; 
        this.radius.style.borderColor = '#' + this.colour;
    }

    drawNode() {
        document.body.append(this.element);
        document.body.append(this.radius);
    }

    setSelectedNode() {
        let selectedNodeNameElem = document.getElementById('selectedDivNumber');
        selectedNodeNameElem!.innerHTML = this.id.toString();
    }


    /**
     * During Abacus training, to simulate the node degrees, the
     * nodes will need to swap between maps.
     */
    swappingMap = false;
    justSwappedMap = false;
    swappingMapNewJunction: Junction|undefined;
    swapMap(newJunction: Junction) {
        this.swappingMap = true;
        this.swappingMapNewJunction = newJunction;
    }

    randomlyMove() {
        // choose new junction
        let randomJunction = this.curJunction.getRandomConnectedJunction(this.prevJunction);
        
        // calculate how long based on distance and speed
        let a = this.curJunction.x - randomJunction.x;
        let b = this.curJunction.y - randomJunction.y;
        let timeTaken = Math.sqrt(a*a + b*b);

        timeTaken /= Node.MOVEMENT_SPEED;

        timeTaken = timeTaken * 50 *  (this.settings.MAX_SIMULATION_SPEED - this.settings.simSpeed);

        this.initialiseNode();
        this.drawNode();

        if(this.justSwappedMap) {
            timeTaken = 1;
        } 

        this.nodeAnimation = this.element.animate([
            { left: (this.x - Node.ELEMENT_SIZE / 2) + 'px', top: (Node.HEADER_OFFSET + this.y - Node.ELEMENT_SIZE / 2) + 'px' },
            { left: (randomJunction.x - Node.ELEMENT_SIZE / 2) + 'px', top: (Node.HEADER_OFFSET + randomJunction.y - Node.ELEMENT_SIZE / 2) + 'px' }
        ], timeTaken);

        this.radiusAnimation = this.radius.animate([
            { left: (this.x - this.settings.nodeRadius / 2) + 'px', top: (Node.HEADER_OFFSET + this.y - this.settings.nodeRadius / 2) + 'px' },
            { left: (randomJunction.x - this.settings.nodeRadius / 2) + 'px', top: ( Node.HEADER_OFFSET + randomJunction.y - this.settings.nodeRadius / 2) + 'px' }
        ], timeTaken);

        this.justSwappedMap = false;

        this.nodeAnimation.onfinish = () => {
            this.x = randomJunction.x;
            this.y = randomJunction.y

            this.prevJunction = this.curJunction;
            this.curJunction = randomJunction;

            if(this.swappingMap && this.swappingMapNewJunction != undefined) {
                this.prevJunction = this.swappingMapNewJunction.getRandomConnectedJunction();
                this.curJunction = this.swappingMapNewJunction;
                this.swappingMapNewJunction = undefined;
                this.swappingMap = false;
                this.justSwappedMap = true;
            }

            this.randomlyMove();
        }
    }


    getPositionAtCenter(element: HTMLElement) {
        const {top, left, width, height} = element.getBoundingClientRect();
        return {
          x: left + width / 2,
          y: top + height / 2
        };
      }
     
    getDistanceBetweenElements(a: HTMLElement, b: HTMLElement) {
       const aPosition = this.getPositionAtCenter(a);
       const bPosition = this.getPositionAtCenter(b);
     
       return Math.hypot(aPosition.x - bPosition.x, aPosition.y - bPosition.y);  
     }

    /**
     * Is this node in the range of another node? IE. is it within the dotted circle.
     * @param node 
     */
    isInRange(node: Node) {
        return this.getDistanceBetweenElements(this.element, node.element) <= this.settings.nodeRadius;
    }


    pauseNode() {
        this.nodeAnimation.pause();
        this.radiusAnimation.pause();
    }

    unpauseNode() {
        this.nodeAnimation.play();
        this.radiusAnimation.play();
    }
}